import React from "react";
import AppIcon from "./AppIcon"
const AppPagination = ({
  currentPage = 1,
  totalPages = 10,
  onPageChange,
}) => {
  // Guard against invalid values
  const safeTotalPages = Math.max(1, Number.isFinite(totalPages) ? totalPages : 1);
  const safeCurrentPage = Math.min(
    Math.max(Number.isFinite(currentPage) ? currentPage : 1, 1),
    safeTotalPages
  );

  const getPages = () => {
    const pages = [];

    if (safeTotalPages <= 7) {
      // Show all pages if 7 or fewer
      for (let i = 1; i <= safeTotalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      // Determine what pages to show around current page
      let showStartEllipsis = false;
      let showEndEllipsis = false;
      let startPage = 2;
      let endPage = safeTotalPages - 1;

      if (safeCurrentPage <= 4) {
        // Near the start: show 2, 3, 4, 5
        startPage = 2;
        endPage = Math.min(5, safeTotalPages - 1);
        showEndEllipsis = safeTotalPages > 6;
      } else if (safeCurrentPage >= safeTotalPages - 3) {
        // Near the end: show last few pages
        startPage = Math.max(2, safeTotalPages - 4);
        endPage = safeTotalPages - 1;
        showStartEllipsis = safeTotalPages > 6;
      } else {
        // In the middle: show current page ± 1
        startPage = safeCurrentPage - 1;
        endPage = safeCurrentPage + 1;
        showStartEllipsis = true;
        showEndEllipsis = true;
      }

      // Add start ellipsis if needed
      if (showStartEllipsis && startPage > 2) {
        pages.push("...");
      }

      // Add pages in range
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Add end ellipsis if needed
      if (showEndEllipsis && endPage < safeTotalPages - 1) {
        pages.push("...");
      }

      // Always show last page
      if (safeTotalPages > 1) {
        pages.push(safeTotalPages);
      }
    }

    return pages;
  };

  const handlePageChange = (page) => {
    if (!onPageChange) return;
    if (page < 1 || page > safeTotalPages) return;
    if (page === safeCurrentPage) return;
    onPageChange(page);
  };

  return (
    <div className="max-w-full overflow-x-auto pb-1" style={{ WebkitOverflowScrolling: "touch" }}>
    <div className="inline-flex min-w-0 items-center gap-1 rounded-xl border border-gray-200 bg-white">
      {/* Prev */}
      <button
        onClick={() => handlePageChange(safeCurrentPage - 1)}
        disabled={safeCurrentPage === 1}
        className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-40"
      >
        <AppIcon name="arrowLeft"/>
      </button>

      {/* Pages */}
      {getPages().map((page, index) =>
        page === "..." ? (
          <span
            key={`pagination-ellipsis-${index}-page-${page}`}
            className="px-2 text-gray-400"
          >
            ...
          </span>
        ) : (
          <button
            key={page}
            onClick={() => handlePageChange(page)}
            className={`flex h-9 w-9 items-center justify-center text-sm font-medium
              ${
                page === safeCurrentPage
                  ? "bg-gray-100 text-gray-900"
                  : "text-gray-500 hover:bg-gray-100"
              }`}
          >
            {page}
          </button>
        )
      )}

      {/* Next */}
      <button
        onClick={() => handlePageChange(safeCurrentPage + 1)}
        disabled={safeCurrentPage === safeTotalPages}
        className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-40"
      >
       <AppIcon name="arrowRight"/>
      </button>
    </div>
    </div>
  );
};

export default AppPagination;
